import React from 'react';
import { useAuth } from '../AuthContext';
import { brandingFromUser, PLATFORM_BRAND } from '../utils/tenantBranding';

const ReportFooter = () => {
  const { user } = useAuth();
  const branding = brandingFromUser(user);
  const showPoweredBy = branding.hasCustomLogo && branding.businessName !== PLATFORM_BRAND.businessName;

  return (
    <footer className="report-page-footer">
      <div className="report-page-footer-title">{branding.businessName}</div>
      <div className="report-page-footer-muted">
        Internal business report
        {showPoweredBy ? ` · Powered by ${PLATFORM_BRAND.platformName}` : ''}
      </div>
    </footer>
  );
};

export default ReportFooter;
